<template>
  <div>
    <div class="box" v-if="!isDesktop">
      <img :src="channelData.bgUrl" />
      <h3>欢迎您，来到{{ channelData.channelName }}</h3>
      <van-form class="form">
        <van-field
          v-model="ruleForm.phone"
          :maxlength="11"
          type="tel"
          placeholder="请输入手机号"
          class="input"
          style="margin-bottom: 0.16rem"
          clearable
        ></van-field>
        <p style="color: red; margin-bottom: 0.16rem; height: 0.5rem">{{ errMsg }}</p>
        <p class="tips">访问前，请完成手机验证</p>
        <XrkSlideVerify
          ref="verification"
          :options="verificationOptions"
          @success="checkSuccessful"
          @close="verifyClose"
        >
          <van-button
            type="primary"
            class="confirmBtn"
            @click="goSms"
            :disabled="sendLock || !this.agreement"
          >{{ sendText }}</van-button>
        </XrkSlideVerify>
      </van-form>
      <van-checkbox v-model="agreement" class="checkbox">
        我同意遵守
        <span style="color: #3667ec" @click="jump">《医生汇聚合SaaS使用服务协议》</span>
      </van-checkbox>
    </div>
    <div v-if="isDesktop">
      <PcRegiser :channelData="channelData"></PcRegiser>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { customerUser, index, getVerification } from '@/api/ajax';
import { yshLogin } from '@/service/login';
import PcRegiser from './components/pcRegiser';

export default {
  components: {
    PcRegiser
  },
  data() {
    return {
      agreement: true,
      ruleForm: {
        phone: '',
        imgVerifyCode: ''
      },
      time: new Date().getTime(),
      channelData: {},
      sendLock: false,
      timer: null,
      sendText: '获取验证码',
      errMsg: '',
      verificationOptions: {
        // 接口请求 防抖
        remoteTimerInterval: 800,
        errorText: '请控制拼图块对齐缺口',
        successText: '验证成功',
        remoteApi: {
          initImages: getVerification,
          checkVerification: position => {
            return customerUser.sendMessageCode({
              ...this.ruleForm,
              ...position
            });
          }
        },
        errorAnimationDuration: 800
      }
    };
  },
  computed: {
    ...mapState({
      isDesktop: state => state.living.isDesktop
    }),
    imgUrl() {
      return `${customerUser.verifyImgCode}?phone=${this.ruleForm.phone}&v=${this.time}`;
    }
  },
  methods: {
    ...mapActions(['savePhone']),
    changePic() {
      this.time = new Date().getTime();
    },
    validate(item) {
      this.errMsg = '';
      if (/^1[0-9]{10}$/.test(item)) {
        return true;
      } else {
        return false;
      }
    },
    goSms() {
      const toNext = () => {
        this.sendLock = true;
        this.sendText = 60;
        this.$refs['verification'].visible = true;
      };
      if (!this.validate(this.ruleForm.phone)) {
        this.$toast('请输入正确的手机号');
      } else if (!this.agreement) {
        this.$toast('请阅读用户协议并遵守');
      } else {
        if (this.channelData.visitRestrictType == 5) {
          customerUser
            .queryWhiteList({
              phone: this.ruleForm.phone
            })
            .then(res => {
              if (res.data.data == 1) {
                toNext();
              } else {
                this.errMsg = res.data.message;
              }
            });
        } else {
          toNext();
        }
      }
    },
    verifyClose() {
      clearInterval(this.timer);
      this.sendText = '获取验证码';
      this.sendLock = false;
    },
    checkSuccessful() {
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.sendText > 0) {
          this.sendText -= 1;
        } else {
          clearInterval(this.timer);
          this.sendText = '获取验证码';
          this.sendLock = false;
        }
      }, 1000);
      this.savePhone(this.ruleForm);
      this.$router.push({
        name: 'sms'
      });
    },
    jump() {
      window.location.href =
        'https://cdn.yxvzb.com/WEB/SaaS/polymerization/agreement/c.html?t=' +
        Date.now();
    }
  },
  async created() {
    console.log(this.isDesktop, '2');
    // 注册YSH来源用户
    yshLogin.call(this);
    const {
      data: { data }
    } = await index.channelData();
    this.channelData = data;
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  }
};
</script>
<style lang="less" scoped>
.box {
  padding: 0.85rem 0.53rem;
  padding-top: 1.2rem;
  text-align: center;
  img {
    width: 1.49rem;
    height: 1.49rem;
    border-radius: 50%;
    display: inline-block;
  }
  h3 {
    margin-top: 0.48rem;
    font-size: 0.61rem;
  }
  .form {
    margin-top: 0.64rem;
    .van-cell {
      padding: 0;
      width: 8.51rem;
      height: 1.47rem;
      background: #f6f6f6;
      border-radius: 0.73rem;
      margin: 0 auto;
      /deep/input {
        text-align: center;
        height: 1.47rem;
      }
    }
    p {
      font-size: 0.32rem;
      color: #323235;
      margin-bottom: 0.53rem;
      &.tips {
        font-size: 0.37rem;
        color: #acacac;
        line-height: 0.61rem;
        margin-bottom: 0.43rem;
      }
    }
  }
  .confirmBtn {
    width: 8.51rem;
    height: 1.47rem;
    background: #3665ec;
    border-radius: 0.73rem;
    margin-top: 0;
    span {
      font-weight: normal;
      font-size: 0.48rem;
    }
  }
  .input {
    /deep/ .van-field__clear {
      font-size: 0.8rem;
      opacity: 0.7;
      position: absolute;
      right: 0.3rem;
    }
  }
}
.checkbox {
  position: fixed;
  bottom: 0.67rem;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
